export const Logo = ({ className = "" }) => {
  return (
    <span
      className={`inline-flex items-center shrink-0 ${className}`}
      style={{ aspectRatio: "406 / 182" }}
    >
      <img
        src="/shebeka_logo.png"
        alt="Shebeka"
        width={406}
        height={182}
        className="h-full w-auto max-w-full object-contain object-left dark:hidden"
        decoding="async"
      />
      <img
        src="/shebeka_logo_dark.png"
        alt="Shebeka"
        width={406}
        height={182}
        className="h-full w-auto max-w-full object-contain object-left hidden dark:block drop-shadow-[0_0_10px_rgba(221,168,53,0.15)]"
        decoding="async"
      />
    </span>
  );
};
